/* YŪ SEI footer reveal. Footer-local input forwarding only; the working homepage
   controller is not modified. Fixed-position hit targets do not reliably chain
   wheel input into Horizon's desktop .page-wrapper scroll container. */
(() => {
  'use strict';
  const shell = document.querySelector('[data-yu-footer-shell]');
  if (!shell) return;
  const desktop = matchMedia('(min-width: 990px)');
  const root = () => desktop.matches ? document.querySelector('.page-wrapper') : document.scrollingElement;
  let frame = 0;
  function measure() {
    frame=0;
    const surface=shell.querySelector('.yu-footer');
    if(surface) document.documentElement.style.setProperty('--yu-footer-surface',getComputedStyle(surface).backgroundColor);
    const height=shell.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--yu-footer-height',height+'px');
    const viewport=window.visualViewport?.height || window.innerHeight;
    const header=document.querySelector('#header-component')?.getBoundingClientRect().height || 60;
    document.body.classList.toggle('yu-footer-static',height+header+24>viewport);
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(measure);}
  function isLocked(container){return document.documentElement.hasAttribute('scroll-lock') || document.body.classList.contains('yu-ritual-drawer-open') || getComputedStyle(container).overflowY==='hidden';}
  function nestedCanScroll(start,dy){
    for(let node=start instanceof Element?start:null;node&&node!==shell;node=node.parentElement){
      const css=getComputedStyle(node);
      if(/auto|scroll/.test(css.overflowY) && node.scrollHeight>node.clientHeight+1 && (dy>0?node.scrollTop+node.clientHeight<node.scrollHeight-1:node.scrollTop>0))return true;
    }
    return false;
  }
  shell.addEventListener('wheel',event=>{
    if(!desktop.matches||event.defaultPrevented||event.ctrlKey||event.metaKey)return;
    const container=root();if(!container||isLocked(container))return;
    const factor=event.deltaMode===1?16:event.deltaMode===2?container.clientHeight:1;
    const dx=event.deltaX*factor,dy=event.deltaY*factor;
    if(!Number.isFinite(dy)||!dy||Math.abs(dy)<Math.abs(dx)||nestedCanScroll(event.target,dy))return;
    // Only prevent the otherwise ineffective fixed-footer event when forwarding.
    if(event.cancelable)event.preventDefault();
    container.scrollBy({top:dy,behavior:'instant'});
  },{passive:false});
  // Touch on the fixed footer is native on phones. Desktop touch screens need
  // the same container forwarding; no manipulation of link click events.
  let touch=null;
  shell.addEventListener('touchstart',e=>{touch=desktop.matches&&e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
  shell.addEventListener('touchmove',e=>{
    if(!touch||e.touches.length!==1)return;
    const t=e.touches[0],dy=touch.y-t.clientY,dx=touch.x-t.clientX;touch={x:t.clientX,y:t.clientY};
    const container=root();if(!container||isLocked(container)||Math.abs(dy)<Math.abs(dx)||nestedCanScroll(e.target,dy))return;
    if(e.cancelable)e.preventDefault();container.scrollBy({top:dy,behavior:'instant'});
  },{passive:false});
  ['touchend','touchcancel'].forEach(type=>shell.addEventListener(type,()=>{touch=null;},{passive:true}));
  const resize=new ResizeObserver(schedule);resize.observe(shell);
  addEventListener('resize',schedule,{passive:true});window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  document.fonts?.ready.then(schedule);document.addEventListener('shopify:section:load',schedule);measure();
})();

/* Keep the mobile product bar clear of the fixed, revealed footer. */
(() => {
  const init = () => {
    if (!document.body.classList.contains("template-product")) return;
    const main = document.querySelector("#MainContent");
    const footer = document.querySelector("#YuSiteFooter");
    if (!main || !footer || !document.querySelector("sticky-add-to-cart")) return;
    const mobile = matchMedia("(max-width: 749px), (hover: none) and (pointer: coarse) and (orientation: landscape) and (max-height: 500px)");
    let frame = 0;
    const update = () => {
      frame = 0;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      document.body.classList.toggle("yu-product-footer-revealed", mobile.matches && main.getBoundingClientRect().bottom <= bottom);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener("scroll", schedule, { passive: true, capture: true });
    window.addEventListener("resize", schedule, { passive: true });
    window.visualViewport?.addEventListener("resize", schedule, { passive: true });
    window.visualViewport?.addEventListener("scroll", schedule, { passive: true });
    if (window.ResizeObserver) { const observer = new ResizeObserver(schedule); observer.observe(main); observer.observe(footer); }
    schedule();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
